import { X } from "lucide-react";
import type { FilterState } from "@/components/FilterPanel";
import { makeDefaultFilters } from "@/components/FilterPanel";

const categoriaLabel: Record<string, string> = {
  abbigliamento: "Abbigliamento",
  scarpe: "Scarpe",
  accessori: "Accessori",
};

interface Props {
  filters: FilterState;
  maxPrice: number;
  onChange: (f: FilterState) => void;
}

function Chip({ label, onRemove }: { label: string; onRemove: () => void }) {
  return (
    <span className="inline-flex items-center gap-1.5 bg-stone-900 text-white text-[10px] tracking-widest uppercase px-3 py-1.5">
      {label}
      <button
        onClick={onRemove}
        className="hover:text-stone-300 transition-colors flex-shrink-0"
        aria-label={`Rimuovi ${label}`}
      >
        <X className="size-2.5" />
      </button>
    </span>
  );
}

export function ActiveFiltersBar({ filters, maxPrice, onChange }: Props) {
  const chips: { label: string; onRemove: () => void }[] = [];

  if (filters.categoria) {
    chips.push({
      label: categoriaLabel[filters.categoria] ?? filters.categoria,
      onRemove: () => onChange({ ...filters, categoria: "", subCategoria: "", taglia: "" }),
    });
  }

  if (filters.subCategoria) {
    chips.push({
      label: filters.subCategoria.charAt(0).toUpperCase() + filters.subCategoria.slice(1),
      onRemove: () => onChange({ ...filters, subCategoria: "" }),
    });
  }

  if (filters.taglia) {
    chips.push({
      label: `Taglia ${filters.taglia}`,
      onRemove: () => onChange({ ...filters, taglia: "" }),
    });
  }

  if (filters.brand) {
    chips.push({
      label: filters.brand,
      onRemove: () => onChange({ ...filters, brand: "" }),
    });
  }

  for (const colore of filters.colori) {
    chips.push({
      label: colore.charAt(0).toUpperCase() + colore.slice(1),
      onRemove: () => onChange({ ...filters, colori: filters.colori.filter((c) => c !== colore) }),
    });
  }

  if (filters.prezzoMin > 0 || filters.prezzoMax < maxPrice) {
    chips.push({
      label: `€${filters.prezzoMin} – €${filters.prezzoMax}`,
      onRemove: () => onChange({ ...filters, prezzoMin: 0, prezzoMax: maxPrice }),
    });
  }

  if (chips.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mb-6">
      {chips.map((chip) => (
        <Chip key={chip.label} label={chip.label} onRemove={chip.onRemove} />
      ))}
      <button
        onClick={() => onChange(makeDefaultFilters(maxPrice))}
        className="text-[10px] tracking-widest uppercase text-stone-400 hover:text-stone-900 transition-colors underline underline-offset-2 ml-1"
      >
        Azzera tutto
      </button>
    </div>
  );
}
